/**
 * Country-flag emojis often render as "US" / "JP" letter pairs on Windows
 * instead of colorful flags. Use text labels in that case.
 */
export function supportsFlagEmojis() {
  if (typeof window === "undefined") {
    return true;
  }

  if (/Windows/i.test(navigator.userAgent)) {
    return false;
  }

  try {
    const canvas = document.createElement("canvas");
    canvas.width = 2;
    canvas.height = 2;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return false;
    }
    ctx.textBaseline = "top";
    ctx.font = "16px Arial";
    ctx.fillText("🇺🇸", 0, 0);
    const { data } = ctx.getImageData(0, 0, 2, 2);
    return data.some((value, index) => index % 4 === 3 && value !== 0);
  } catch {
    return false;
  }
}
